module.exports = __webpack_public_path__ + "img/icon-close-inspector.f164c47e.svg";